export default {
  RECOVER_CHOICE: 'RECOVER_CHOICE',
  ENTER_DATA_FOR_RECOVER: 'ENTER_DATA_FOR_RECOVER',
  CHECK_ENTERED_RECOVER_DATA: 'CHECK_ENTERED_RECOVER_DATA',
  EMAIL_SENT_INFO: 'EMAIL_SENT_INFO',
  ENTER_NEW_PASSWORD: 'ENTER_NEW_PASSWORD',
  USER_LOCKDOWN: 'USER_LOCKDOWN',
  USER_ERROR: 'USER_ERROR',
  NEW_PASSWORD_SAVED: 'NEW_PASSWORD_SAVED'
};